/* Sarah Ford homepage v4 — carousels (dots) + mobile menu toggle */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.sfReady === '1') return;
    root.dataset.sfReady = '1';

    var track = root.querySelector('[data-sf-track]');
    var scope = root.closest('[data-sf-carousel-scope]') || root;
    var dots = Array.prototype.slice.call(scope.querySelectorAll('[data-sf-dot]'));
    var pages = parseInt(root.dataset.sfPages, 10) || 1;
    var page = 0;

    if (!track || pages < 2) {
      if (dots.length && dots[0]) dots[0].classList.add('is-active');
      return;
    }

    function go(p) {
      page = ((p % pages) + pages) % pages;
      track.style.transform = 'translateX(-' + page * 100 + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === page); });
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });
    go(0);
  }

  function initBurger(nav) {
    if (nav.dataset.sfReady === '1') return;
    nav.dataset.sfReady = '1';
    var btn = nav.querySelector('[data-sf-burger]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sf-carousel]').forEach(initCarousel);
    document.querySelectorAll('.sf-nav').forEach(initBurger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when the Shopify theme editor reloads a section */
  document.addEventListener('shopify:section:load', initAll);
})();
